webpackJsonp([0],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "28QG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ "6XRP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_LinkTargets__ = __webpack_require__("ScBB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_LinkTargets__["a" /* default */]],
  data: function data() {
    return {
      footerLinks: [{
        text: 'Board of County Commissioners',
        href: 'https://hillsboroughcounty.org/government/board-of-county-commissioners'
      }, {
        text: 'County Locations',
        href: 'https://hillsboroughcounty.org/residents/citizens/county-locations'
      }, {
        text: 'Jobs',
        href: 'https://hillsboroughcounty.org/about-hillsborough/jobs'
      }, {
        text: 'Contact Us',
        href: 'https://hillsboroughcounty.org/about-hillsborough/contact-us'
      }],
      socialLinks: [{
        name: 'Facebook',
        href: 'https://www.facebook.com/HillsboroughFL/',
        iconClass: 'fa-facebook'
      }, {
        name: 'Twitter',
        href: 'https://twitter.com/HillsboroughFL',
        iconClass: 'fa-twitter'
      }, {
        name: 'YouTube',
        href: 'https://www.youtube.com/user/HillsboroughCounty',
        iconClass: 'fa-youtube'
      }, {
        name: 'InstaGram',
        href: 'https://www.instagram.com/hillsboroughfl/',
        iconClass: 'fa-instagram'
      }, {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/hillsboroughfl',
        iconClass: 'fa-linkedin'
      }],
      logoUrl: 'https://raw.githubusercontent.com/Commbocc/html-wrapper/master/src/assets/hc-logo-horizontal-RGB_drkbgrd.png'
    };
  }
});

/***/ }),

/***/ "9gzd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9qln":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L9eR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcFooter_vue__ = __webpack_require__("6XRP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72dcec56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcFooter_vue__ = __webpack_require__("g3S1");
function injectStyle (ssrContext) {
  __webpack_require__("9gzd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72dcec56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("9qln")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap__ = __webpack_require__("K3J8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#hc-main',
  extends: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
});

/***/ }),

/***/ "PyiM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcBanner_vue__ = __webpack_require__("28QG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4795bbe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcBanner_vue__ = __webpack_require__("nmTJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4795bbe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ScBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    linkTargets: {
      type: String,
      default: '_self'
    }
  }
});

/***/ }),

/***/ "eMYj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcNavSearchForm_vue__ = __webpack_require__("mTMR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78666c5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcNavSearchForm_vue__ = __webpack_require__("nS6Y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcNavSearchForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78666c5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcNavSearchForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g3S1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"bg-secondary py-5",attrs:{"id":"hc-footer"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-center text-center"},[_c('div',{staticClass:"col-md-4 mb-4 order-md-4"},[_c('ul',{staticClass:"mb-0"},_vm._l((_vm.footerLinks),function(link){return _c('li',{staticClass:"list-inline-item mx-3"},[_c('a',{staticClass:"text-white",attrs:{"href":link.href,"target":_vm.linkTargets}},[_vm._v("\n              "+_vm._s(link.text)+"\n            ")])])}))]),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-4 order-md-1"},[_c('a',{attrs:{"href":"https://hillsboroughcounty.org","target":_vm.linkTargets}},[_c('img',{staticClass:"logo img-fluid",attrs:{"src":_vm.logoUrl,"alt":"Hillsborough County Logo"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-4 order-md-12"},[_c('ul',{staticClass:"list-inline mb-0 hide-external-indicator"},_vm._l((_vm.socialLinks),function(link){return _c('li',{staticClass:"list-inline-item"},[_c('a',{staticClass:"text-white",attrs:{"href":link.href,"title":link.name,"target":"_blank","aria-label":link.name}},[_c('span',{staticClass:"fa fa-fw",class:link.iconClass,attrs:{"aria-hidden":"true"}})])])}))])]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center small mt-3 mb-0"},[_c('a',{staticClass:"text-white hide-external-indicator",attrs:{"href":"https://goo.gl/maps/jetXJdK71mu","target":"_blank"}},[_vm._v("\n        601 E. Kennedy Blvd."),_c('br'),_vm._v("\n        Tampa, FL 33602\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "geF4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      navLinks: [{
        text: 'Residents',
        identifier: 'residents-children',
        linkClass: null,
        children: []
      }, {
        text: 'Businesses',
        identifier: 'businesses-children',
        linkClass: null,
        children: []
      }, {
        text: 'Government',
        identifier: 'government-children',
        linkClass: null,
        children: []
      }, {
        text: 'About Hillsborough',
        identifier: 'about-hillsborough-children',
        linkClass: null,
        children: []
      }, {
        text: 'I Want To...',
        identifier: 'i-want-to-children',
        linkClass: 'text-primary',
        children: []
      }]
    };
  },

  methods: {
    fetchNavChildren: function fetchNavChildren() {
      var _this = this;

      this.navLinks.forEach(function (x) {
        var url = 'https://gist.githubusercontent.com/mccarthyk/93e7ece6a2d1ba903261c6f25479a6cd/raw/2b01d85967dfb2a7727caba9b8f8f44b5010fea9/' + x.identifier + '.json';
        _this.$http.get(url).then(function (res) {
          x.children = res.body.filter(function (c) {
            return c['Show in Menu'];
          });
        });
      });
    }
  },
  mounted: function mounted() {
    this.fetchNavChildren();
  }
});

/***/ }),

/***/ "mTMR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['action', 'method', 'target', 'showFilters'],
  data: function data() {
    return {
      filters: [{
        key: 'article',
        text: 'Web Pages',
        icon: 'fa-file-o',
        checked: true
      }, {
        key: 'story',
        text: 'Newsroom Stories',
        icon: 'fa-newspaper-o',
        checked: true
      }, {
        key: 'documents',
        text: 'Documents',
        icon: 'fa-file-pdf-o',
        checked: false
      }, {
        key: 'events',
        text: 'Events',
        icon: 'fa-calendar',
        checked: false
      }, {
        key: 'locations',
        text: 'Locations',
        icon: 'fa-map-marker',
        checked: false
      }, {
        key: 'departments',
        text: 'Departments',
        icon: 'fa-building-o',
        checked: false
      }]
    };
  }
});

/***/ }),

/***/ "md8n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcNavigation_vue__ = __webpack_require__("siLz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_544e2722_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcNavigation_vue__ = __webpack_require__("tfG5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_544e2722_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcNavigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nS6Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"action":_vm.action,"method":_vm.method,"target":_vm.target}},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-8"},[_c('hr',{staticClass:"mb-2 mb-lg-0 d-lg-none"}),_vm._v(" "),_c('div',{staticClass:"input-group input-group-lg",attrs:{"id":"hc-nav-search-input-group"}},[_c('input',{ref:"searchInput",staticClass:"form-control",attrs:{"name":"q","type":"search","placeholder":"Search For...","aria-label":"Search Input","required":""}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('hr',{staticClass:"mt-2 mt-lg-0 mb-0 mb-lg-2"})])]),_vm._v(" "),(_vm.showFilters)?_c('fieldset',{staticClass:"d-none d-lg-block"},[_c('legend',{staticClass:"sr-only"},[_vm._v("Filters")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center small"},_vm._l((_vm.filters),function(filter){return _c('label',{staticClass:"px-2"},[_c('input',{attrs:{"type":"checkbox","aria-label":filter.text},domProps:{"value":filter.key,"checked":filter.checked}}),_vm._v(" "),_c('span',{staticClass:"fa fa-fw",class:filter.icon,attrs:{"aria-hidden":"true"}}),_vm._v("\n        "+_vm._s(filter.text)+"\n      ")])}))]):_vm._e(),_vm._v(" "),(false)?_c('div',{attrs:{"role":"group"}},[(_vm.showFilters)?_c('ul',{staticClass:"list-inline small text-center d-none d-lg-block mt-3 mb-0"},_vm._l((_vm.filters),function(filter){return _c('li',{staticClass:"list-inline-item px-2"},[_c('input',{attrs:{"name":"t","type":"checkbox","id":("searchFilter" + (filter.key)),"aria-labelledby":("searchFilterLabel" + (filter.key))},domProps:{"value":filter.key,"checked":filter.checked}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":("searchFilter" + (filter.key)),"id":("searchFilterLabel" + (filter.key))}},[_c('span',{staticClass:"fa fa-fw",class:filter.icon}),_vm._v("\n          "+_vm._s(filter.text)+"\n        ")])])})):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-link",attrs:{"type":"submit"}},[_c('span',{staticClass:"fa fa-fw fa-search",attrs:{"aria-label":"Search"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nmTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"hc-banner jumbotron jumbotron-fluid bg-info text-white my-0 py-4"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"hc-banner-title font-weight-bold m-0"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Breadcrumb Navigation"}},[_c('ol',{staticClass:"breadcrumb hc-banner-breadcrumb mb-0"},[_vm._t("default"),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v(_vm._s(_vm.title))])],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "siLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HcNavSearchForm__ = __webpack_require__("eMYj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_NavLinks__ = __webpack_require__("geF4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_LinkTargets__ = __webpack_require__("ScBB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_NavLinks__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_LinkTargets__["a" /* default */]],
  props: {
    logoHref: {
      type: String,
      default: 'https://hillsboroughcounty.org'
    },
    logoTarget: {
      type: String,
      default: '_self'
    },
    // search form props
    showForm: {
      type: Boolean,
      default: true
    },
    formAction: {
      type: String,
      default: 'https://hillsboroughcounty.org/search'
    },
    formMethod: {
      type: String,
      default: 'get'
    },
    formTarget: {
      type: String,
      default: '_self'
    },
    formShowFilters: {
      type: Boolean,
      default: true
    },
    customNav: {
      type: Boolean,
      default: false
    }
  },
  components: { NavSearchForm: __WEBPACK_IMPORTED_MODULE_1__HcNavSearchForm__["a" /* default */] },
  data: function data() {
    return {
      logoUrl: 'https://github.com/Commbocc/html-wrapper/raw/master/src/assets/hc-logo-horizontal-RGB.png'
    };
  },

  methods: {
    focusSearch: function focusSearch() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
        _this.$refs.searchForm.$refs.searchInput.focus();
      });
    },
    showSearchWhenMobile: function showSearchWhenMobile() {
      if (this.$refs.navToggler.offsetLeft > 0) {
        this.$refs.searchDropdown.classList.add('show');
      } else {
        this.$refs.searchDropdown.classList.remove('show');
      }
    }
  },
  mounted: function mounted() {
    window.onload = this.showSearchWhenMobile;
    window.onresize = this.showSearchWhenMobile;
  }
});

/***/ }),

/***/ "tfG5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand-lg navbar-light bg-white",attrs:{"id":"hc-nav","aria-label":"Site Navigation"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":_vm.logoHref,"target":_vm.logoTarget}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logoUrl,"alt":"Hillsborough County Logo"}})]),_vm._v(" "),_c('button',{ref:"navToggler",staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav ml-auto"},[(_vm.showForm)?_c('li',{staticClass:"nav-item order-lg-12 dropdown"},[_c('a',{staticClass:"nav-link dropdown-toggle d-none d-lg-inline-block",attrs:{"href":"#","title":"Search","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"},on:{"click":function($event){_vm.focusSearch()}}},[_c('span',{staticClass:"fa fa-fw fa-search",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Search")])]),_vm._v(" "),_c('div',{ref:"searchDropdown",staticClass:"dropdown-menu"},[_c('NavSearchForm',{ref:"searchForm",attrs:{"action":_vm.formAction,"method":_vm.formMethod,"target":_vm.formTarget,"show-filters":"formShowFilters"}})],1)]):_vm._e(),_vm._v(" "),(_vm.customNav)?_vm._t("default"):_vm._l((_vm.navLinks),function(link){return _c('li',{staticClass:"nav-item order-lg-1 dropdown"},[_c('a',{staticClass:"nav-link dropdown-toggle",class:link.linkClass,attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n            "+_vm._s(link.text)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},[_c('h4',{staticClass:"d-none d-lg-block text-info font-serif font-weight-bold"},[_vm._v(_vm._s(link.text))]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu-2-col"},_vm._l((link.children),function(child){return _c('a',{staticClass:"dropdown-item",attrs:{"href":("https://hillsboroughcounty.org/" + (child.ItemUrl)),"target":_vm.linkTargets}},[_vm._v("\n                "+_vm._s(child.DisplayName)+"\n              ")])}))])])})],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HcNavigation__ = __webpack_require__("md8n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HcBanner__ = __webpack_require__("PyiM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HcFooter__ = __webpack_require__("L9eR");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    HcNavigation: __WEBPACK_IMPORTED_MODULE_0__components_HcNavigation__["a" /* default */], HcBanner: __WEBPACK_IMPORTED_MODULE_1__components_HcBanner__["a" /* default */], HcFooter: __WEBPACK_IMPORTED_MODULE_2__components_HcFooter__["a" /* default */]
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.js